import { memo, useCallback } from 'react';
import { Checkbox, Icon, Popover, Text, useTheme } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

const IntegrationItem = memo(({ integration, isChecked, onToggle }) => {
    const theme = useTheme();
    const isNative = integration.connector;

    const handleClick = useCallback(() => {
        if (!isNative) onToggle(integration.id, !isChecked);
    }, [integration.id, isChecked, isNative, onToggle]);

    return (
        <div className="fm-automation-builder__integration-item" onClick={handleClick}>
            <Checkbox checked={isChecked} isDisabled={isNative} color="actionMinor" />
            <Text>{integration.name}</Text>
            {isNative && (
                <Popover
                    trigger={['hover']}
                    placement="top"
                    content={
                        <div className="fm-automation-builder__integration-tooltip">
                            <Text color={theme.colors.utility.textSecondary}>
                                {getLiteral('automation_trigger_integration_not_available')}
                            </Text>
                        </div>
                    }
                >
                    <span className="fm-automation-builder__integration-info">
                        <Icon name="info" color={theme.colors.grey[500]} />
                    </span>
                </Popover>
            )}
        </div>
    );
});

export default IntegrationItem;
